<template>
  <div class="layout-profile">
    <div>
      <img class="avatar"
      :src="user_info.images && user_info.images.length > 0 ? user_info.images[0].path : '../assets/layout/images/profiles/default.png'"
      :alt="user_info.usename"/>
    </div>
    <button class="p-link layout-profile-link" @click="onClick">
      <span class="username">{{user_info.first_name}} {{user_info.last_name}}</span>
      <i class="pi pi-fw pi-cog"></i>
    </button>
    <transition name="layout-submenu-wrapper">
      <ul v-show="expanded">
        <!--
        <li>
          <button class="p-link"><i class="pi pi-fw pi-user"></i><span>Account</span></button>
        </li>
        -->
        <!-- <li>
          <button class="p-link"><i class="pi pi-fw pi-inbox"></i><span>Notifications</span><span
                  class="menuitem-badge">2</span></button>
        </li> -->
        <!--                <li><button class="p-link"><i class="pi pi-fw pi-power-off"></i><span>Logout</span></button></li>-->
        <!--        <router-link to="/login" tag="li">-->
        <li>
          <button class="p-link" @click="onResetPassword"><i class="pi pi-fw pi-undo"></i><span>Reset Password</span></button>
        </li>
        <li>
          <button class="p-link" @click="onLogout"><i class="pi pi-fw pi-power-off"></i><span>Logout</span></button>
        </li>
        <!--        </router-link>-->
      </ul>
    </transition>
  </div>
</template>

<script>
  import router from "./router";

  export default {
    data() {
      return {
        expanded: false,
        user_info: {}
      }
    },
    methods: {
      onClick(event) {
        this.expanded = !this.expanded;
        event.preventDefault();
      },
      onLogout() {
        localStorage.removeItem("token");
        localStorage.removeItem("user_info");
        router.push("/login");
      },
      onResetPassword() {
        localStorage.removeItem("token");
        localStorage.removeItem("user_info");
        router.push("/forgot");
      }
    },
    mounted() {
      this.user_info = (this.$store.state.user_info && this.$store.state.token) ? JSON.parse(this.$store.state.user_info) : this.onLogout()
    }
  }
</script>

<style scoped lang="scss">
  .avatar {
      border-radius: 2em;
  }
</style>